/* import __COLOCATED_TEMPLATE__ from './email-follow-up.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

type EmailFollowUpOption = 'follow_up' | 'no_follow_up';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    step: Fin;
    isReadOnly: boolean;
  };
}

export default class EmailFollowUp extends Component<Signature> {
  @service declare intl: IntlService;

  get selectedOption(): EmailFollowUpOption {
    return (this.args.step?.emailFollowUpType as EmailFollowUpOption) || 'follow_up';
  }

  set selectedOption(value: EmailFollowUpOption) {
    this.args.step.emailFollowUpType = value;
  }

  get options() {
    return [
      {
        value: 'follow_up' as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-follow-up',
        subtitleTranslationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-follow-up-subtitle',
      },
      {
        value: 'no_follow_up' as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-no-follow-up',
        subtitleTranslationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-no-follow-up-subtitle',
      },
    ];
  }

  @action
  setSelectedOption(option: EmailFollowUpOption) {
    this.args.step.emailFollowUpType = option;
  }

  get shouldShowPreview() {
    return this.selectedOption !== 'no_follow_up';
  }

  get previewText() {
    return this.intl.t(
      'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.preview-text',
    );
  }

  get selectedLabel() {
    switch (this.selectedOption) {
      case 'follow_up':
        return this.intl.t(
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.summary-follow-up',
        );
      case 'no_follow_up':
        return this.intl.t(
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.summary-no-follow-up',
        );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::EmailFollowUp': typeof EmailFollowUp;
    'workflows/graph-editor/node-items/steps/fin/sections/email-follow-up': typeof EmailFollowUp;
  }
}
